export default "__VITE_ASSET__C_ezmIaL__";